import React from "react";
import { Box, Button, Typography } from "@mui/material";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { Link } from "react-router-dom";

const NoBlogsFound = ({ message = "No blogs found." }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            minHeight="200px"
            py={4}
        >
            <SentimentDissatisfiedIcon color="disabled" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h6" color="text.secondary" sx={{mb:4}}>
                {message}
            </Typography>

            <Button
                variant="outlined"
                component={Link}
                to="/blog"
                sx={{
                    color: "secondary.main",
                    "& :hover": {
                        borderColor: "secondary.main",
                    }
                }}
            >
                View All Blogs
            </Button>

        </Box>
    );
};

export default NoBlogsFound;
